/** @flow */
import React from 'react';
import styled from 'styled-components';
import LoadingSpinner from 'common/components/LoadingSpinner';
import GeolocationReach from '../../../../domain/GeolocationReach';
import GeoMap from './GeoMap';
import GeoMapLayout from '../../../../domain/GeoMapLayout';

const LOADING_ID = 'loading-geo-map-loading-spinner';

const CenterWrapper = styled.div`
  justify-content: center;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
`;

type Props = {
  geolocalisation: GeolocationReach[],
  layout?: GeoMapLayout;

  height: number;
};

function LoadingGeoMap(props: Props) {
  if (!props.layout) {
    return (
      <CenterWrapper id={LOADING_ID}>
        <LoadingSpinner size="medium" />
      </CenterWrapper>
    );
  }

  return (
    <GeoMap
      id="geomap"
      geolocalisation={props.geolocalisation}
      layout={props.layout}
      height={props.height}
      zoomable
    />
  );
}

export {
  LoadingGeoMap,
  LOADING_ID,
};

export default LoadingGeoMap;



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/demography/map/LoadingGeoMap.js